import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Link18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.21816 2.60108L7.34098 4.46826L7.33817 4.47109C6.52176 5.29182 6.06348 6.40238 6.06348 7.56001C6.06348 8.71669 6.521 9.82636 7.33613 10.6469L7.82424 11.145L8.89556 10.0951L8.40557 9.59505L8.40163 9.59109C7.86482 9.05143 7.56348 8.3212 7.56348 7.56001C7.56348 6.79945 7.86433 6.06979 8.40032 5.53026L10.2788 3.66179L10.2847 3.65582C11.3821 2.53959 13.2377 2.53962 14.3351 3.65584L14.3976 3.71842C14.9153 4.24408 15.2054 4.95223 15.2054 5.69001C15.2054 6.42779 14.9153 7.13593 14.3977 7.66158L13.3996 8.65968L14.4602 9.72034L15.4602 8.72036L15.4638 8.7167C16.2594 7.91018 16.7054 6.82287 16.7054 5.69001C16.7054 4.55716 16.2594 3.46983 15.4639 2.66332L15.4023 2.60179C13.7261 0.899473 10.8948 0.899155 9.21816 2.60108Z'
      fill='currentColor'
    />
    <path
      d='M10.2156 6.72507L10.7038 7.22318C11.5189 8.04371 11.9764 9.15337 11.9764 10.31C11.9764 11.4653 11.5199 12.5737 10.7066 13.394L8.78477 15.3958C7.05392 17.1563 4.25087 17.0516 2.53962 15.3403L2.536 15.3367C1.74046 14.5302 1.29443 13.4429 1.29443 12.31C1.29443 11.1772 1.74046 10.0899 2.536 9.28333L2.53962 9.27969L3.53962 8.27969L4.60028 9.34035L3.6022 10.3384C3.08459 10.8641 2.79443 11.5722 2.79443 12.31C2.79443 13.0478 3.08458 13.7559 3.60218 14.2816C4.72525 15.4054 6.56824 15.5074 7.71221 14.3472L9.63822 12.3411C10.175 11.8014 10.4764 11.0712 10.4764 10.31C10.4764 9.54883 10.175 8.8186 9.63822 8.27894L9.63429 8.27496L9.14429 7.77496L10.2156 6.72507Z'
      fill='currentColor'
    />
  </Svg>
);

Link18.displayName = 'Link18';
export default Link18;
